import Vue from 'vue';
import Router from 'vue-router';
//import AuthService from '../service/AuthService';


// Containers
//const DefaultContainer = () => import('@/containers/DefaultContainer');
//const DefaultContainerClient = () => import('@/containers/DefaultContainerClient');

// Views - admin
/* const AdminDashboard = () => import('@/views/admin/Dashboard/Dashboard');

// const AdminUserList = () => import('@/views/admin/User/UserList');
// const AdminUserForm = () => import('@/views/admin/User/UserForm');

const AdminSurveyList = () => import('@/views/admin/Survey/SurveyList');
const AdminSurveyForm = () => import('@/views/admin/Survey/SurveyForm');
const AdminApplicationList = () => import('@/views/admin/Application/ApplicationList');
const AdminApplicationForm = () => import('@/views/admin/Application/ApplicationForm'); 
// const AdminUserList = () => import('@/views/admin/User/UserList');
// const AdminUserForm = () => import('@/views/admin/User/UserForm');*/

// Views - auth
const AuthPage404 = () => import('@/views/auth/Page404');
/* const AuthLogin = () => import('@/views/auth/Login');
const AuthRegister = () => import('@/views/auth/Register');
const AuthChangePassword = () => import('@/views/auth/ChangePassword');
const AuthForgotPassword = () => import('@/views/auth/ForgotPassword');
const AuthResetPassword = () => import('@/views/auth/ResetPassword'); */


// Views - client
//const ClientHome = () => import('@/views/client/Home');
const ClientSurvey = () => import('@/views/client/Survey/SurveyResult');
const ClientSurveyResultSuccessful = () => import('@/views/client/Survey/SurveyResultSuccessful');
const ClientSurveyUser = () => import('@/views/client/Survey/SurveyResultUser');

Vue.use(Router)

const router = new Router({
  base: window.MyConfig.pathDefault,
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: '/',
      redirect: window.MyConfig.defaultRouter,
      // component: DefaultContainerClient
    },
    {
      path: '/',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      redirect: '/survey',
      children: [
        {
          path: 'survey',
          name: 'Client-Survey',
          component: ClientSurvey,
          meta: {
            allowAccess: ['*'],
            page: 'client'
          },
        },
        {
          path: 'successful',
          name: 'Client-Survey-Result-Successful',
          component: ClientSurveyResultSuccessful,
          meta: {
            allowAccess: ['*'],
            page: 'client'
          },
        },
        {
          path: 's/:id',
          name: 'Client-Survey-User',
          component: ClientSurveyUser,
          meta: {
            allowAccess: ['*'],
            page: 'client'
          }
        }
      ]
    },
    // {
    //   path: '/admin',
    //   redirect: '/admin/home',
    //   component: DefaultContainer,
    //   children: [
    //     {
    //       path: 'home',
    //       name: 'Admin-Home',
    //       component: AdminDashboard,
    //       meta: {
    //         allowAccess: ['*'],
    //         page: 'admin'
    //       },
    //     },
    //
    //     //User
    //     {
    //       path: 'User',
    //       name: 'Admin-User',
    //       redirect: '/admin/User/list',
    //       component: {
    //         render(c) {
    //           return c('router-view')
    //         }
    //       },
    //       children: [
    //         {
    //           path: 'list',
    //           name: 'Admin-User-list',
    //           component: AdminUserList,
    //           meta: {
    //             allowAccess: ['Admin'],
    //             page: 'admin'
    //           },
    //         },
    //         {
    //           path: 'create',
    //           name: 'Admin-User-create',
    //           component: AdminUserForm,
    //           meta: {
    //             allowAccess: ['Admin'],
    //             page: 'admin'
    //           },
    //         },
    //         {
    //           path: 'update/:id',
    //           name: 'Admin-User-update',
    //           component: AdminUserForm,
    //           meta: {
    //             allowAccess: ['Admin'],
    //             page: 'admin'
    //           },
    //         },
    //         {
    //           path: 'detail/:id',
    //           name: 'Admin-User-detail',
    //           component: AdminUserForm,
    //           meta: {
    //             allowAccess: ['Admin'],
    //             page: 'admin'
    //           },
    //         },
    //       ]
    //     },
    //     //Application
    //     {
    //       path: 'Application',
    //       name: 'Admin-Application',
    //       redirect: '/admin/Application/list',
    //       component: {
    //         render(c) {
    //           return c('router-view')
    //         }
    //       },
    //       children: [
    //         {
    //           path: 'list',
    //           name: 'Admin-Application-list',
    //           component: AdminApplicationList,
    //           meta: {
    //             allowAccess: ['Admin'],
    //             page: 'admin'
    //           },
    //         },
    //         {
    //           path: 'create',
    //           name: 'Admin-Application-create',
    //           component: AdminApplicationForm,
    //           meta: {
    //             allowAccess: ['Admin'],
    //             page: 'admin'
    //           },
    //         },
    //         {
    //           path: 'update/:id',
    //           name: 'Admin-Application-update',
    //           component: AdminApplicationForm,
    //           meta: {
    //             allowAccess: ['Admin'],
    //             page: 'admin'
    //           },
    //         },
    //         {
    //           path: 'detail/:id',
    //           name: 'Admin-Application-detail',
    //           component: AdminApplicationForm,
    //           meta: {
    //             allowAccess: ['Admin'],
    //             page: 'admin'
    //           },
    //         },
    //       ]
    //     }
    //   ]
    // },
    {
      path: '/auth',
      // redirect: '/auth/404',
      name: 'Auth',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '404',
          name: 'Auth-Page404',
          component: AuthPage404,
          meta: {
            page: 'auth'
          },
        },
        // {
        //   path: 'login',
        //   name: 'Auth-Login',
        //   component: AuthLogin,
        //   meta: {
        //     page: 'auth'
        //   },
        // },
        // {
        //   path: 'register',
        //   name: 'Auth-Register',
        //   component: AuthRegister,
        //   meta: {
        //     page: 'auth'
        //   },
        // },
        // {
        //   path: 'changepassword',
        //   name: 'Auth-ChangePassword',
        //   component: AuthChangePassword,
        //   meta: {
        //     page: 'auth'
        //   },
        // },
        // {
        //   path: 'forgotPassword',
        //   name: 'Auth-ForgotPassword',
        //   component: AuthForgotPassword,
        //   meta: {
        //     page: 'auth'
        //   },
        // },
        // {
        //   path: 'resetPassword',
        //   name: 'Auth-ResetPassword',
        //   component: AuthResetPassword,
        //   meta: {
        //     page: 'auth'
        //   },
        // }
      ]
    }

  ]
})
export default router;

//check route
router.beforeEach(function (to, from, next) {
  if (from.name != to.name) {
    /* if (to.meta.page && to.meta.page == 'admin') {
      AuthService.me().then(
        res => {
          console.log(res);
          window.localStorage.setItem("currentUser", JSON.stringify(res.result));
          if (to.meta.allowAccess && to.meta.allowAccess.indexOf("*") == 0) {
            next();
          } else {
            if (res.result && res.result.roles && res.result.roles.length > 0) {
              var access = false;
              res.result.roles.forEach(item => {
                if (to.meta.allowAccess && to.meta.allowAccess.indexOf(item) != -1) {
                  access = true;
                }
              })
              if (access) {
                next();
              } else {
                window.toastr.warning("Không có quyền truy cập trang này")
              }
            }
          }
        }
      )
        .catch(error => {
          window.localStorage.removeItem("currentUser");
          next('/auth/login');
        });
      next();
    } else */ if (to.meta.page /* && to.meta.page != 'admin' */) {
      next();
    } else {
      next('/auth/404');
    }
  } else {
    if (!to.name) {
      next('/auth/404');
    } else {
      next();
    }
  }

});

// router.beforeEach(function (to, from, next) {
//   debugger;
//   if (from.name != to.name) {
//     debugger;
//     if (!to.meta.page || to.meta.page != 'client') {
//       next('/auth/404');
//     } else {
//       next();
//     }
//   } else {
//     if (!to.name) {
//       next('/auth/404');
//     } else {
//       next();
//     }
//   }
//
//
// })
